import React from 'react';
import * as calssnames from 'classnames';

import './styles.scss';

const List = ({list = [], isListLeft, isMarkerLine, isSmallSize, isBigPaddingElement}) => {
	return (
		<ul
			className={
				calssnames('main-list',{
					"main-list--isListLeft": isListLeft,
					"main-list--isMarkerLine": isMarkerLine,
					"main-list--isSmallSize": isSmallSize,
					"main-list--isBigPaddingElement": isBigPaddingElement,
				})
			}
		>
			{list.map((el, i) => (
				<li 
					key={i}
					className="main-list__element"
				>
					{el}
				</li>
			))}
		</ul>
	)
};

export default List;